<template>
    <transition name="modal">
        <div class="modal-mask" id="clinicsModal" v-click-outside="off">
            <searchInput v-model="search" style="margin:10px; margin-left: 30px;" />
            <b-list-group v-if="items.length > 0" style="max-height: 380px; overflow: auto;">
                <b-list-group-item :class="{active: item.title === activeClinic}"  class="clinic" v-for="item in items" :key="item.id"
                @click="pushClinic(item)" style="display:flex"
                > <div style="width:50px; height:50px; flex: 0 0 50px; border-radius:50%; display:flex; margin-right:5px"> 
                    <div style="width:100%; height:100%; background-size: cover" :style="{ 'background-image': `url(${item.logo}`}"></div></div> {{item.title}}</b-list-group-item>
            </b-list-group>
            <div v-else style="margin:10px"> Не найдено </div>
            <b-pagination-nav style="align-self:center" v-model="current_page" :link-gen="linkGen" :number-of-pages="pages" use-router></b-pagination-nav>
        </div>
    </transition>    
</template>

<script>
import { adminApi } from '@app/services';
import ClickOutside from '@app/directives/click-outside.directive';
import searchInput from './searchInput';
import toastr from 'toastr';
import { debounce } from 'lodash';


export default {
    components: {
        searchInput
    },
    directives: {
        ClickOutside
    },
    props: {
        position: Number,
        activeClinic: String
    },
    data() {
        return {
            items: [],
            pages: 1,
            current_page: 1,
            search: ''
        };
    },
    mounted() {
        this.load(5, this.current_page, this.search);
        document.getElementById('clinicsModal').style.left = this.position + 'px';
    },
    methods: {
        linkGen(pageNum) {
            return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
      async load(limit, offset, search) {
          await adminApi.getAll(limit, offset, search).then(res => {
            this.items = res.items;
            this.pages = res.pages;
        });
      },
      off() {
      this.$emit('clickOutside');
    },
    pushClinic(item) {
        this.$emit('push', item);
    }
    },
    watch: {
        current_page() {
            this.load(5, this.current_page, this.search);
        },
        search: debounce(async function(value) {
      const offset = this.pageSize * (this.currentPage - 1);
      this.current_page = 1;
      await this.load(5, 1, value);
    }, 500)
    }
    
};
</script>

<style lang="scss" scoped>

.clinic {
    cursor: pointer;
}
.clinic:hover {
    background: linear-gradient(to right, #e5cef8, transparent);
}
.active {
    background: linear-gradient(to right, #c5a1e4, transparent);
}

 .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 70px;
  left: 0;
  width: 328px;
  height: 380px;
  background: linear-gradient(to right, whitesmoke, white);
  box-shadow: 5px 0 5px 0 gray;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: opacity 0.3s ease;
}
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
::v-deep .backInp {
    height: 45px;
}
::v-deep .searhIcon {
    top: -5px;
}
</style>